import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Box, Typography } from "@mui/material";
import { withFormCache } from './FormCacheResources';

// Define initial state for all form fields to be cached
const initialState = {
    email: "",
    event: "delivered",
    transmissionId: ""
};

const CreateTransmissionStatus = ({
    onResponse,
    formState,
    setEmail,
    setEvent,
    setTransmissionId,
    clearForm
}) => {
    const eventOptions = [
        {
            "key": "Dropped",
            "value": "dropped"
        },
        {
            "key": "Deferred",
            "value": "deferred"
        },
        {
            "key": "Bounce",
            "value": "bounce"
        },
        {
            "key": "Delivered",
            "value": "delivered"
        }
    ];
    const webhookUrl = process.env.REACT_APP_WEBHOOK_URL;

    const sendTransmissionRequest = () => {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: formState.email,
                event: formState.event,
                transmission_id: formState.transmissionId,
            }),
        };

        const date = new Date();
        const time = `[${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}] `;
        onResponse(`${time}Request Sent to: ${webhookUrl}`);

        fetch(webhookUrl, requestOptions)
            .then((response) => {
                const newResponse = `${time}Response: ${response.status}(${response.statusText})`;
                onResponse(newResponse);
            })
            .catch((e) => {
                console.error(e);
                const newResponse = `${time}Response: Error - ${e.message}`;
                onResponse(newResponse);
            });
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleEventChange = (event) => {
        setEvent(event.target.value);
    };

    const handleTransmissionIdChange = (event) => {
        setTransmissionId(event.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formState.email.trim() || !formState.event || !formState.transmissionId.trim()) {
            alert("Please fill in all fields: Email, Event, and Transmission ID.");
            return;
        }
        sendTransmissionRequest();
    };

    return (
        <Box sx={{ fontFamily: "'Arial', sans-serif", padding: "20px", width: "100%" }} className="create-transmission-status">
            <Typography variant="h3" sx={{ color: "#333", fontSize: "1.5rem", marginBottom: "15px", borderBottom: "2px solid #eee", paddingBottom: "5px" }}>
                Create Transmission Status
            </Typography>
            <Box component="form" onSubmit={handleSubmit} sx={{ backgroundColor: "#f8f9fa", padding: "15px", borderRadius: "4px", width: "100%", maxWidth: "500px", marginTop: "10px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", display: "flex", flexDirection: "column", gap: "15px" }} className="transmission-form-container">
                <TextField label="Recipient Email" name="email" type="email" value={formState.email} onChange={handleEmailChange} placeholder="Enter email" variant="outlined" fullWidth sx={{ backgroundColor: 'white' }} required />
                <FormControl fullWidth variant="outlined" required>
                    <InputLabel id="transmission-status-select-label">Status Type</InputLabel>
                    <Select labelId="transmission-status-select-label" id="transmission-status-select" value={formState.event} label="Status Type" onChange={handleEventChange} sx={{ backgroundColor: 'white' }}>
                        {eventOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.key}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField label="Transmission ID" name="transmissionId" type="text" value={formState.transmissionId} onChange={handleTransmissionIdChange} placeholder="Enter transmission ID" variant="outlined" fullWidth sx={{ backgroundColor: 'white' }} required />
                <Box sx={{ marginTop: "1em", display: "flex", justifyContent: "center", gap: "10px" }} className="transmission-button-group">
                    <Button type="submit" variant="contained" color="primary">Send</Button>
                    <Button type="button" variant="outlined" onClick={() => clearForm()}>Clear</Button>
                </Box>
            </Box>
        </Box>
    );
};

export default withFormCache(CreateTransmissionStatus, 'createTransmissionStatus', initialState);